
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createsuscripcionop8hb } from '../../api/suscripcionop8hb.api'

import './eliminary4z80k.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Peliminary4z80k = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id69013a718e5aed52dc82d90c" >

      <div id="iw4j" className="">
      
      <div id="i6ssn" className="">
      
      <div id="imeimh" className="">
      
      <div id="i7ixxo" className="">
      
      <div id="i6ztzg" className="">
      
      <img
        className=""
        id="ia8bbi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3jt9qt.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="iwrtu"
          href="mailto:info@example.com"
        >
          
    <div id="i06b9" className="">
    <>info@dicipgo.com</>
    </div>
    
        </a>
        
      <div id="iamrom" className="">
      
      <img
        className=""
        id="iywkvr"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhanptg4.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="i6ymq"
          href="tel:+21236547898"
        >
          
    <div id="ilrna" className="">
    <>+504 3334-8846</>
    </div>
    
        </a>
        
      <div id="ivz97" className="">
      
      <img
        className=""
        id="i8i7g"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhanna44.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="id9ue">
        <>Lunes - Viernes (08AM - 05PM)</>
      </div>
      
      </div>
      
      <div id="ijmhwx" className="">
      
      </div>
      
      <div id="i6q70s" className="">
      
      </div>
      
      <div id="ie0ovm" className="">
      
      </div>
      
      <div id="i1q826" className="">
      
      </div>
      
      </div>
      
      <div id="i58lg7" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i0zkbr" className="">
      
      <div id="i0fboh" className="">
      
        <a
          target=""
          className=""
          id="iytouh"
          href={`/`}
        >
          
      <img
        className=""
        id="idepm2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3p0ayf.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="i76z8x" className="">
      
        <a
          target=""
          className=""
          id="idlxcg"
          href={`/`}
        >
          
    <div id="i7imp2" className="">
    <>INICIO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ix0zc7"
          href={`/nosotros`}
        >
          
    <div id="i2vzcj" className="">
    <>CONÓCENOS</>
    </div>
    
        </a>
        
        <LoftyDropdownComponent
          id="im0qqv"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="ixwopc" className="gjs-dropdown-menu-trigger ">
<>ÚNETE</></div>

            </>
          }
          childrenHover={
            <>
              <div id="ihz1li" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="iojw0f"
          href={`/socio_motorista`}
        >
          
    <div id="id1tnc" className="">
    <>SOCIO MOTORISTA</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ibs9om"
          href={`/publicidad`}
        >
          
    <div id="ialxa1" className="">
    <>PUBLICIDAD</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="ii4h1h"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="i687zt" className="gjs-dropdown-menu-trigger ">
<>POLÍTICAS</></div>

            </>
          }
          childrenHover={
            <>
              <div id="i8aj9g" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="iy44hw"
          href={`/terminos_politicas`}
        >
          
    <div id="ilmv8g" className="">
    <>TERMINOS & POLITICAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ikc7sg"
          href={`/eliminar_cuenta`}
        >
          
    <div id="ik8exo" className="">
    <>ELIMINAR CUENTA</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="iief0t"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="icx7l1" className="gjs-dropdown-menu-trigger ">
<>RESPUESTAS</></div>

            </>
          }
          childrenHover={
            <>
              <div id="ixlphb" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="ie11fh"
          href={`/preguntas_respuestas`}
        >
          
    <div id="i5wol3" className="">
    <>PREGUNTAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="imdl75"
          href="#"
        >
          
    <div id="idim8j" className="">
    <>NOTICIAS !PRONTO!</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <a
          target=""
          className=""
          id="ianf7t"
          href={`/contactanos`}
        >
          
    <div id="i3870v" className="">
    <>CONTACTANOS</>
    </div>
    
        </a>
        
      </div>
      
      <div id="iacot" className="">
      
        <a
          target=""
          className=""
          id="i96vd"
          href="https://api.whatsapp.com/send/?phone=33348846&text&type=phone_number&app_absent=0"
        >
          
      <img
        className=""
        id="ikof4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhanr6xa.png"
        alt="undefined"
      />
      
    <div id="iwe9i" className="">
    <>Via WhatsApp</>
    </div>
    
        </a>
        
      <img
        className=""
        id="ilg8m"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3k9u97.png"
        alt="undefined"
      />
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      </li>
      
        <a
          target=""
          className=""
          id="ilpkjt"
          href={`/`}
        >
          
    <div id="i2bynj" className="">
    <>INICIO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="icafgg"
          href={`/nosotros`}
        >
          
    <div id="iv7kdm" className="">
    <>CONÓCENOS</>
    </div>
    
        </a>
        
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
        <LoftyDropdownComponent
          id="isoayi"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="i536rc" className="gjs-dropdown-menu-trigger ">
<>UNETE
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="ifxvuy" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="i3hxau"
          href={`/socio_motorista`}
        >
          
    <div id="ip699g" className="">
    <>SOCIO MOTORISTA</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iufdal"
          href={`/publicidad`}
        >
          
    <div id="iaawbk" className="">
    <>PUBLICIDAD</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="iq0mnk"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="iqbgg9" className="gjs-dropdown-menu-trigger ">
<>POLITICA
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="ifwcix" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="i61hhc"
          href={`/terminos_politicas`}
        >
          
    <div id="iw1wej" className="">
    <>TERMINOS & POLITICAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i4v96p"
          href={`/eliminar_cuenta`}
        >
          
    <div id="i6rlr2" className="">
    <>ELIMINAR CUENTA</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="iwiyle"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="ip6o3a" className="gjs-dropdown-menu-trigger ">
<>RESPUESTAS
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="i6eavm" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="i3szb9"
          href={`/preguntas_respuestas`}
        >
          
    <div id="i84e89" className="">
    <>PREGUNTAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ir7afk"
          href="#"
        >
          
    <div id="i0l31h" className="">
    <>NOTICIAS !PRONTO¡</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <a
          target=""
          className=""
          id="i9uup8"
          href={`/contactanos`}
        >
          
    <div id="ik63yd" className="">
    <>CONTACTANOS</>
    </div>
    
        </a>
        
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ivzb1" className="">
      
      <div id="ivqya9" className="">
      
      <div className="" id="iy8fd4">
        <>Cuentas y uso de Información</>
      <br className="" id="" />
      
      </div>
      
      <div id="ibrbhg" className="">
      
        <a
          target=""
          className=""
          id="iwktxu"
          href={`/`}
        >
          
    <div id="ioiyzt" className="">
    <>Inicio &gt;&gt;</>
    </div>
    
        </a>
        
      <div className="" id="ijnx16">
        <>Eliminar Cuenta</>
      </div>
      
      </div>
      
      </div>
      
      <div id="imjksk" className="">
      
      </div>
      
      <div id="iji7ez" className="">
      
      <div id="ii1p2g" className="">
      
      <div className="" id="iypo7n">
        <>1. Para eliminar tu cuenta en la aplicación “DicipGo”, sigue estos pasos:</>
      <br className="" id="" />
      
      </div>
      
      <div id="iow7hu" className="">
      
      <div id="i4wyzl" className="">
      
      <img
        className=""
        id="iz0uhp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="izm7wi">
        <> 1. Ingresa a la pantalla de "Tu Perfil", donde podrás ver tu información como usuario.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="ikncam" className="">
      
      <div id="ixtzg5" className="">
      
      <img
        className=""
        id="ipwu52"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iiqxej">
        <> 2. En la parte inferior, haz clic en el botón "Eliminar cuenta".</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i3xmhl" className="">
      
      <div id="i0vj0i" className="">
      
      <img
        className=""
        id="itb0by"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ism0dh">
        <> 3. Aparecerá una alerta de confirmación. Si deseas continuar, haz clic en el botón "Sí".</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i0gsfy" className="">
      
      <div id="itpapf" className="">
      
      <img
        className=""
        id="ieg86l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="in31k9">
        <> 4. Luego, aparecerá otra alerta de confirmación. Haz clic en el botón "Estoy seguro".</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div className="" id="i9fa3o">
        <>2. Una vez realizados estos pasos, la empresa DicipGo eliminará la siguiente información:</>
      <br className="" id="" />
      
      </div>
      
      <div id="ifxhif" className="">
      
      <div id="itmj4u" className="">
      
      <img
        className=""
        id="im3xs6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ibepi1">
        <> 1. Correo eléctronico</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="irnosy" className="">
      
      <div id="ijjnwk" className="">
      
      <img
        className=""
        id="iqt1j4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="int3tr">
        <> 2. Teléfono</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="ipfmu4" className="">
      
      <div id="iyy6gv" className="">
      
      <img
        className=""
        id="itzeoh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="izpza6">
        <> 3. DNI</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="ip3uzp" className="">
      
      <div id="ibpu1k" className="">
      
      <img
        className=""
        id="innffn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iou215">
        <> 4. Licencia de Conducción</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="iv3oq8" className="">
      
      <div id="i0ydn6" className="">
      
      <img
        className=""
        id="igahyh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i41gqk">
        <> 5. Captura de perfil de alguna aplicación.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="id7eyy" className="">
      
      <div id="i58heu" className="">
      
      <img
        className=""
        id="idsd4e"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iw3i3w">
        <> 6. Antecedentes Penales</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i5efdb" className="">
      
      <div id="isw6uv" className="">
      
      <img
        className=""
        id="igybo3"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i6yima">
        <> 7. Antecedentes Policiales</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i7g1xn" className="">
      
      <div id="iov8t7" className="">
      
      <img
        className=""
        id="isk4ut"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1ejek.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i3tlik">
        <> 8. Fotografía de perfil.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div className="" id="isbv04">
        <>3. Sin embargo, los datos que se mantienen dentro de la app de DicipGo para su funcionamiento son los datos:</>
      <br className="" id="" />
      
      </div>
      
      <div id="icm4ll" className="">
      
      <div id="i2mklb" className="">
      
      <img
        className=""
        id="i6dr3k"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1gzer.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="icz6co">
        <> 1. Viajes realizados.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i9vune" className="">
      
      <div id="id86bf" className="">
      
      <img
        className=""
        id="ivfql9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1gzer.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i3owd2">
        <> 2. Métricas de desempeño</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="ipurl3" className="">
      
      <div id="ijkntu" className="">
      
      <img
        className=""
        id="ia35xy"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhc1gzer.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i7yvda">
        <> 3. Recorrido en kilómetro</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="izx98iy" className="">
      
        <a
          target=""
          className=""
          id="iqteqd"
          href="#"
        >
          
      <img
        className=""
        id="ih8agp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhar4q3t.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="iqyjhz" className="">
      
      <div id="ioo5vd" className="">
      
      <div id="iq1hxl" className="">
      
      <img
        className=""
        id="io67mf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhb3rrtk.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="izx1nj" className="">
      
      <div className="" id="iszoe5">
        <>Política de Privacidad de Dicip Go</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ikgno5">
        <>Dicip Go asegura la eliminación segura de cuentas, cumpliendo con todos los acuerdos establecidos. Protege la información del usuario, garantizando que no será mal utilizada ni compartida sin consentimiento. Se adhiere a las normativas y tratados internacionales de libre comercio, garantizando la privacidad y seguridad de los datos según los más altos estándares legales.</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="idbkqd" className="">
      
      </div>
      
      <div id="i2wkyy" className="">
      
      <div id="idtdzs" className="">
      
      </div>
      
      <div id="ili81h" className="">
      
      <div id="in8v1v" className="">
      
      <img
        className=""
        id="ih7oge"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh5eabfn.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iabbo4">
        <>"Dicip Go, uniendo sueños y creando realidades."</>
      </div>
      
      <div id="i0aklm" className="">
      
      <div id="iiao7j" className="">
      
      <img
        className=""
        id="ihkvgk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhapqszf.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="i498ll"
          href="tel:+21236547898"
        >
          
    <div id="igphxl" className="">
    <>+(504)3334-8846</>
    </div>
    
        </a>
        
      </div>
      
      <div id="iq49kk" className="">
      
      <div id="iv4iez" className="">
      
      <img
        className=""
        id="in61um"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhapot9t.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="idnp2s">
        <>Tegucigalpa, Honduras</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i9jhal" className="">
      
      <div id="ijhd05" className="">
      
      <img
        className=""
        id="i3rkkd"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhapr4sr.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="ikoyxp"
          href="mailto:info@example.com"
        >
          
    <div id="id135y" className="">
    <>info@dicipgo.com</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="itfo5z" className="">
      
      <div className="" id="ig6pu9">
        <>Links Web</>
      <br className="" id="" />
      
      </div>
      
      <div id="igw4ca" className="">
      
      <div id="igbbew" className="">
      
      </div>
      
      <div id="i7jg5x" className="">
      
      </div>
      
      <div id="i0cs3j" className="">
      
      </div>
      
      </div>
      
      <ul
        className=""
        id="i9jpdk"
        name="">
        
        <a
          target=""
          className=""
          id="ietl9z"
          href={`/`}
        >
          
    <div id="izfsug" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iqjy9k"
          href={`/nosotros`}
        >
          
    <div id="idaplq" className="">
    <>Nosotros</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iva6x9"
          href={`/socio_motorista`}
        >
          
    <div id="if5gpc" className="">
    <>Socios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iv6xlh"
          href={`/publicidad`}
        >
          
    <div id="i9ee1g" className="">
    <>Publicidad</>
    </div>
    
        </a>
        
      </ul>
      
      </div>
      
      <div id="i0hajc" className="">
      
      <div className="" id="i1ry5b">
        <>Links Informativos</>
      <br className="" id="" />
      
      </div>
      
      <div id="indb5tt" className="">
      
      <div id="ijw2nr" className="">
      
      </div>
      
      <div id="i98yzz" className="">
      
      </div>
      
      <div id="ic6wg8w" className="">
      
      </div>
      
      </div>
      
      <ul
        className=""
        id="i0xug0v"
        name="">
        
        <a
          target=""
          className=""
          id="iglsjel"
          href={`/preguntas_respuestas`}
        >
          
    <div id="i5ifst9" className="">
    <>Preguntas frecuentes</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iqur2hg"
          href="#"
        >
          
    <div id="il6qymo" className="">
    <>Noticias</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i06brkc"
          href={`/contactanos`}
        >
          
    <div id="i52b9sc" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i9jwj9h"
          href={`/eliminar_cuenta`}
        >
          
    <div id="igvbgf6" className="">
    <>Eliminación de Cuentas</>
    </div>
    
        </a>
        
      </ul>
      
      </div>
      
      <div id="ibyhr7" className="">
      
      <div className="" id="i2gad2j">
        <>¡Suscríbete!</>
      <br className="" id="" />
      
      </div>
      
      <div id="iqf20lh" className="">
      
      <div id="iouqnbe" className="">
      
      </div>
      
      <div id="i0t7w7h" className="">
      
      </div>
      
      <div id="ijggbbk" className="">
      
      </div>
      
      </div>
      
      <div className="" id="ix1u5ym">
        <>Compártenos tu correo electrónico para que permanezcas informado sobre los últimos avances de Dicip Go.</>
      <br className="" id="" />
      
      </div>
      
        <div className="" id="i2lei25">
          
      <form
        id="iu2vtff"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createsuscripcionop8hb({
						token: 'aasdas',
						emailad4px: e.target.emailad4px.value,
					});
					window.location.reload();
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="i4vo85m" className="">
      
      <br className="" id="" />
      
      <input
        name="emailad4px"
        type="text"
        placeholder="Email."
        className=""
        id="igp0qsh"
      />
      
      </div>
      
      <button
        type="submit"
        name=""
        id="id33zr1"
        className=""
        
      >
      
      <div id="iuqrm78" className="">
      <>SUSCRIBETE</>
      </div>
      
      <img
        className=""
        id="iupuxgq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao37c4.png"
        alt="undefined"
      />
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      <div id="ia6axz" className="">
      
      <div className="" id="ikx7mga">
        <>© Copyright 2025 Dicip Go All Rights Reserved. Created by Go Data Monkey</>
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Peliminary4z80k);
  